import { Link } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SignOut, Gear } from "@phosphor-icons/react";

export const BrandMark = ({ light = false, size = 26 }) => (
  <img
    src={`${API}/assets/logo-light`}
    alt="CaminoSign"
    style={{ height: size, width: "auto", display: "block" }}
  />
);

export const TopNav = ({ children }) => {
  const auth = useAuth();
  const user = auth?.user;
  return (
    <header className="sticky top-0 z-40 border-b border-white/10" style={{ background: "#292F34" }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
        <Link to="/" data-testid="brand-home-link" className="flex items-center shrink-0">
          <img src={`${API}/assets/logo-light`} alt="CaminoSign" className="h-6 sm:h-7 w-auto block" />
        </Link>
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          {children}
          {user && (
            <div className="flex items-center gap-2 sm:gap-3 sm:pl-3 sm:ml-1 sm:border-l border-white/10">
              <Link to="/settings" data-testid="account-settings-link" title="Account settings"
                className="text-right hidden md:block leading-tight max-w-[180px] hover:opacity-80 transition-opacity">
                <div className="text-sm text-[#F7F3EF] font-medium truncate">{user.business_name}</div>
                <div className="text-[11px] text-white/50 truncate">{user.email}</div>
              </Link>
              <Link
                to="/settings"
                data-testid="settings-nav-btn"
                title="Account settings"
                className="flex items-center justify-center h-9 w-9 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors shrink-0"
              >
                <Gear size={18} weight="bold" />
              </Link>
              <button
                onClick={auth.logout}
                data-testid="logout-btn"
                title="Log out"
                className="flex items-center justify-center h-9 w-9 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors shrink-0"
              >
                <SignOut size={18} weight="bold" />
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
